import React from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { PairHeadline } from '@root/features/pair/ui/mobile/pair-headline'

import type { WalletAssetModel } from '@root/entities/wallet/atoms'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  asset: WalletAssetModel
} & ClassNameProps

export const WalletAssetHeadline: React.FC<Props> = ({ asset, className }) => {
  const { pair } = asset

  if (!pair) {
    return (
      <TickerContainer className={className}>
        <Ticker ellipsis>{asset.currency.ticker}</Ticker>
      </TickerContainer>
    )
  }

  return <PairHeadline className={className} pair={pair} />
}

const Ticker = styled(Typography).attrs({
  variant: 'body4-bold',
  component: 'div',
})`
  color: var(--text-12);

  display: grid;
  grid-template-columns: auto auto;
  justify-content: start;

  gap: 2px;
  align-content: center;
  align-items: center;

  > svg {
    margin-top: -1px;
  }
`

const TickerContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 4px;
`
